export const CLEAR_ALL_FILTERS = 'CLEAR_ALL_FILTERS'
